function GalleryThumb(props) {
  return (
    <div className="img-wrap">
      <img
        src={props.image}
        className={props.active ? 'active' : ''}
        onClick={props.click}
      />
    </div>
  );
}

export default GalleryThumb;
